export default __webpack_public_path__ + "static/media/prev-NavIC-Clock-7.d713854e.png";